import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CreationProjetService } from '../creation-projet.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, interval, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
  selector: 'app-redirection-pop-up',
  templateUrl: './redirection-pop-up.component.html',
  styleUrls: ['./redirection-pop-up.component.scss']
})
export class RedirectionPopUpComponent implements OnInit {
  isSaved = false;
  isExtracted = false;
  isUploading: boolean;
  private stopPolling$ = new Subject<void>();
  project: any;


  constructor(private router: Router,
    private readonly _snackBar: MatSnackBar,
    private _creationProjetService: CreationProjetService,
    public dialogRef: MatDialogRef<RedirectionPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { }

  ngOnInit(): void {
    this.saveToDatabase();
  }

  saveToDatabase() {
    this._creationProjetService.depotProjectFinancement(
      this.data.company.id,
      this.data.partnerId,
      this.data.formData,
      this.data.mandateId,
      this.data.partnerName,
      this.data.mandateName
    ).subscribe({
      next: res => {
        this.project = res;
        this._snackBar.open('Projet créé avec succès', null, { duration: 2000, panelClass: 'accent-snackbar' });
        this.isSaved = true;
        this.startExtraction(res.projet_Id);
      },
      error: err => {
        this._snackBar.open('Une erreur est survenue lors de la creation du projet', null, { duration: 2000, panelClass: 'accent-snackbar' });
      },
    });
  }

  startExtraction(projet_Id) {
    interval(3000) // every 3 seconds
      .pipe(
        takeUntil(this.stopPolling$), // stop if told
        switchMap(() =>
          this._creationProjetService.checkIfProjectExists(projet_Id)
            .pipe(
              catchError(err => {
                this._snackBar.open(
                  'Une erreur est survenue lors de la vérification du projet',
                  undefined,
                  { duration: 2000, panelClass: 'accent-snackbar' }
                );
                this.isExtracted = false;
                throw err; // rethrow to stop polling on error, or use of(false) if you want to continue
              })
            )
        )
      )
      .subscribe(exists => {
        if (exists) {
          this.isExtracted = true;
          this.stopPolling(); // stop polling once done
          this.redirectAfterExtractionDone();
        }
      });
  }

  stopPolling() {
    this.stopPolling$.next();
    this.stopPolling$.complete();
  }

  //redirect without waiting to the main project list
  redirectWithoutWaiting() {
    // Close the popup and redirect
    this.stopPolling(); // optional: stop polling immediately
    this.router.navigate(['/partner-dossier-project']); // Adjust route accordingly
    this.dialogRef.close(); // Close the dialog
  }

  // redirect after getting the extraction done
  redirectAfterExtractionDone() {
    // Close the popup and redirect
    this.router.navigate(['/fiche-projet-apres-travaux', this.project.projet_Id]);
    this.dialogRef.close(); // Close the dialog
  }

}
